import React, { useState, useEffect } from "react";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from "react-router-dom";
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { useDeadline } from "../../../contexts/DeadlineContext";
const WorkshopNavbar = () => {
    const { offButton, abstractHomeSetup, getAbstractDeadLineStatus } = useDeadline();
    const history = useHistory();
    const SCFMSLOGO = `${process.env.PUBLIC_URL}/Abstract/loginBanerImage/SCFMS2024-logo.png`;
    const eventid = localStorage.getItem('eventid')
   
    return (
        <div>
             <Toolbar
                sx={{
                    background: abstractHomeSetup.color_code_three || '#274A72',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'nowrap',
                    minHeight: { xs: 64, sm: 80, md: 100 }, // Adjust as needed
                    px: { xs: 2, sm: 3 }, // Optional: add horizontal padding
                }}
            >
                {/* Left: Logo */}
                <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                    {abstractHomeSetup?.eventLogo ? (
                        <Box
                            component="img"
                            src={abstractHomeSetup.eventLogo}
                            sx={{
                                width: {
                                    xs: '60px',
                                    sm: '80px',
                                    md: 'clamp(100px, 10vw, 100px)', // Between 100px and 150px depending on screen width
                                },
                                height: 'auto',
                                borderRadius: '50%',
                            }}
                        />
                    ) : (
                        <Typography color="inherit" variant="body2">
                            No Logo
                        </Typography>
                    )}
                </Box>

                {/* Center: Conference Management System */}
                <Box
                    sx={{
                        flex: 2,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                    }}
                >
                    <Typography
                        variant="h6"
                        sx={{
                            color: 'white',
                            fontSize: { xs: '0.9rem', sm: '1.1rem', md: '1.25rem' },
                            fontWeight: 'bold',
                        }}
                    >
                        Workshop Management System
                    </Typography>
                </Box>

                {/* Right: Event Name */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flex: 1 }}>
                    <Typography
                        variant="h6"
                        component="div"
                        sx={{
                            color: 'white',
                            textAlign: 'right',
                            fontSize: { xs: '1rem', sm: '1.25rem' },
                            pr: { xs: 1, sm: 2, md: 3 },
                        }}
                    >
                        {abstractHomeSetup?.event_name || 'Event Name'}
                    </Typography>
                </Box>
            </Toolbar>




        </div>
    );
}

export default WorkshopNavbar;
